import React from 'react';
import PropTypes from 'prop-types';
import { Box, TablePagination as MuiTablePagination } from '@mui/material';
import { useTranslation } from '@app/config/i18n';

const TablePagination = ({
  totalItems,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [1, 2, 5, 10, 25, 50, 100],
  label,
}) => {
  const { t } = useTranslation(['common']);

  return (
    <MuiTablePagination
      sx={{
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
      }}
      component={Box}
      count={totalItems}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={rowsPerPageOptions}
      labelDisplayedRows={({ from, to, count }) =>
        `${from}-${to} ${t('common:of')} ${count}`
      }
      labelRowsPerPage={label || t('common:Rows per page')}
    />
  );
};

TablePagination.propTypes = {
  totalItems: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  label: PropTypes.string,
};

TablePagination.defaultProps = {
  rowsPerPageOptions: [1, 2, 5, 10, 25, 50, 100],
  label: 'Rows per page',
};

export default TablePagination;
